"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _zod = require("zod");

var _index = _interopRequireDefault(require("../cards/index"));

var _widgetContainer = _interopRequireWildcard(require("../widget-container"));

var _utils = require("@insided/deprecated-preact-components/knowledge-base/utils");

var _Metadata = _interopRequireDefault(require("@insided/deprecated-preact-components/knowledge-base/Metadata"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var config = _zod.z.object({
  selectedTemplate: _zod.z.number(),
  displayOnlyParent: _zod.z.boolean()
}).merge(_widgetContainer.widgetContainerConfig).default({
  selectedTemplate: 0,
  displayOnlyParent: true
});

exports.config = config;
var widgetName = 'knowledge_base';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-knowledge_base';
exports.cssAnchorName = cssAnchorName;

var KnowledgeBaseWidget = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(KnowledgeBaseWidget, _Component);

  var _super = _createSuper(KnowledgeBaseWidget);

  function KnowledgeBaseWidget() {
    var _this;

    (0, _classCallCheck2.default)(this, KnowledgeBaseWidget);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "templates", ['big-card', 'small-card']);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderCard", function (category, idx, isChild) {
      var _this$props = _this.props,
          config = _this$props.config,
          attachmentCdn = _this$props.attachmentCdn;
      var selectedTemplate = config.selectedTemplate;

      var _ref = category || {},
          id = _ref.id,
          title = _ref.title,
          children = _ref.children,
          thumbnailImage = _ref.thumbnailImage,
          visibleTopicsCount = _ref.visibleTopicsCount,
          navigationUrl = _ref.url;

      var categoriesData = isChild ? category : children;

      var _getMetadata = (0, _utils.getMetadata)(categoriesData, visibleTopicsCount),
          totalTopicCount = _getMetadata.totalTopicCount,
          categoriesCount = _getMetadata.categoriesCount;

      var imgSrc = "".concat(attachmentCdn).concat(thumbnailImage);
      var childClass = isChild ? "id-".concat(id) : '';
      var hasWidgetTitle = Boolean(config.title);
      var hasWidgetSubtitle = Boolean(config.subtitle);
      var CardHeaderTag = (0, _widgetContainer.genericWidgetHeaderTagCalculator)(hasWidgetTitle, hasWidgetSubtitle);
      return (0, _preact.h)(_index.default, {
        key: id,
        customClass: "knowledge-base__card knowledge-base__card-".concat(_this.templates[selectedTemplate || 0], " ").concat(childClass),
        title: title,
        metadata: (0, _preact.h)(_Metadata.default, {
          totalTopicCount: totalTopicCount,
          categoriesCount: categoriesCount
        }),
        imageSrc: imgSrc,
        headerTag: CardHeaderTag,
        navigation: {
          url: navigationUrl
        }
      });
    });
    return _this;
  }

  (0, _createClass2.default)(KnowledgeBaseWidget, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          config = _this$props2.config,
          categories = _this$props2.categories;
      var title = config.title,
          displayOnlyParent = config.displayOnlyParent;

      if (!categories.length) {
        return null;
      }

      return (0, _preact.h)(_widgetContainer.default, {
        widgetName: "knowledge-base",
        config: config
      }, (0, _preact.h)("div", {
        className: (0, _classnames.default)('full-width Template-brand-featured knowledge-base-container qa-knowledge-base-container custom-knowledge-base')
      }, (0, _preact.h)("div", {
        className: "knowledge-base-category-list"
      }, displayOnlyParent ? categories.map(function (category, idx) {
        return _this2.renderCard(category, idx, false);
      }) : (0, _preact.h)("div", {
        className: "knowledge-base_parent-child-component-wrapper"
      }, categories.map(function (category) {
        var _category$children;

        return (0, _preact.h)("section", {
          className: "knowledge-base_parent-child-component",
          key: category.id
        }, title ? (0, _preact.h)("div", {
          className: "knowledge-base-category-list_parent-title"
        }, category.title) : (0, _preact.h)("h3", {
          className: "widget__heading"
        }, category.title), (0, _preact.h)("div", {
          className: "knowledge-base-category-list"
        }, category === null || category === void 0 ? void 0 : (_category$children = category.children) === null || _category$children === void 0 ? void 0 : _category$children.map(function (subcategory, idx) {
          return _this2.renderCard(subcategory, idx, true);
        })));
      })))));
    }
  }]);
  return KnowledgeBaseWidget;
}(_preact.Component);

var _default = KnowledgeBaseWidget;
exports.default = _default;